import { ColorPalette } from './theme';

const grey: ColorPalette['grey'] = {
  '50': '#fafafa',
  '100': '#f5f5f5',
  '200': '#eeeeee',
  '300': '#e0e0e0',
  '400': '#bdbdbd',
  '500': '#9e9e9e',
  '600': '#757575',
  '700': '#616161',
  '800': '#424242',
  '900': '#333333',
};

export const fitColorPalette = {
  grey,
  common: {
    black: '#000000',
    white: '#ffffff',
  },
  background: {
    default: '#f4efee',
  },
  primary: {
    light: '#FF073B',
    main: '#D4183D',
    dark: '#902935',
    contrastText: '#fff',
  },
  secondary: {
    light: '#F9E7E3',
    main: '#DE9F9F',
    dark: '#D4BBB7',
    contrastText: '#fff',
  },
  warning: {
    light: '#FFC107',
    main: '#FFA000',
    dark: '#FF6F00',
  },
  info: {
    light: '#64B5F6',
    main: '#0288D1',
    dark: '#01579B',
    contrastText: '#fff',
  },
  error: {
    light: '#E57373',
    main: '#F44336',
    dark: '#D32F2F',
  },
  success: {
    light: '#81C784',
    main: '#2e7d32',
    dark: '#1B5E20',
  },
};
